import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import MediaQuery from 'react-responsive';
import { StickyContainer } from 'react-sticky';
import { Row, Col, Accordion } from "react-bootstrap";
import { Image, RichText } from "@sitecore-jss/sitecore-jss-react";
import uniqueId from 'lodash.uniqueid';
import { DividedContainer } from "./DividedContainer";
import Heading from "../heading/Heading";
import { Counter } from "./Counter";
import { SelectableAddon } from "./SelectableAddon";
import { AccordionToggle } from "./AccordionToggle";
import * as UTIL from '../../util'; //ga tracker

import { gaTracker } from '../../util/ga-analytics/gaTracker';
export var CustomizationBase = function CustomizationBase(_ref) {
  var options = _ref.options,
      _ref$multiplesAllowed = _ref.multiplesAllowed,
      multiplesAllowed = _ref$multiplesAllowed === void 0 ? false : _ref$multiplesAllowed,
      optionGroupId = _ref.optionGroupId,
      description = _ref.description,
      defaultOptionName = _ref.defaultOptionName,
      inputType = _ref.inputType,
      mandatory = _ref.mandatory,
      parentId = _ref.parentId,
      isSides = _ref.isSides,
      controlledValues = _ref.controlledValues,
      handleCounter = _ref.handleCounter,
      remaining = _ref.remaining,
      index = _ref.index,
      _ref$isEditMode = _ref.isEditMode,
      isEditMode = _ref$isEditMode === void 0 ? false : _ref$isEditMode,
      _ref$handleCheckbox = _ref.handleCheckbox,
      handleCheckbox = _ref$handleCheckbox === void 0 ? function () {
    return console.log("handleCheckboxRan");
  } : _ref$handleCheckbox,
      _ref$handleRadio = _ref.handleRadio,
      handleRadio = _ref$handleRadio === void 0 ? function () {
    return console.log("handleCheckboxRan");
  } : _ref$handleRadio,
      mods = _ref.mods;
  var accordionId = optionGroupId || uniqueId();
  var element = mods.find(function (option) {
    return option.optionGroupId === optionGroupId;
  });
  var ref = React.createRef();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 990
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 3,
    field: {
      value: description
    }
  }), /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
    className: "visuallyhidden"
  }, description, " - required: ", mandatory), /*#__PURE__*/React.createElement(Row, {
    className: "cb-menu-detail__customization-group"
  }, /*#__PURE__*/React.createElement(CustomizationOptions, {
    defaultOptionName: defaultOptionName,
    options: options,
    inputType: inputType,
    mandatory: mandatory,
    parentId: parentId,
    isSides: isSides,
    controlledValues: controlledValues,
    handleCounter: handleCounter,
    handleRadio: handleRadio,
    handleCheckbox: handleCheckbox,
    remaining: remaining,
    currentElement: element,
    multiplesAllowed: multiplesAllowed,
    isEditMode: isEditMode
  })))), /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 991
  }, /*#__PURE__*/React.createElement(StickyContainer, {
    id: "cb-detail-section-".concat(accordionId),
    className: "cb-accordion__group cb-detail-section"
  }, /*#__PURE__*/React.createElement(Accordion, {
    id: "customization-accordion-".concat(accordionId),
    defaultActiveKey: accordionId,
    key: "customization-accordion-".concat(accordionId)
  }, /*#__PURE__*/React.createElement(AccordionToggle, {
    id: "accordion-heading-".concat(accordionId),
    eventKey: accordionId
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 3,
    field: {
      value: description
    }
  })), /*#__PURE__*/React.createElement(Accordion.Collapse, {
    id: "accordion-panel-".concat(accordionId),
    eventKey: accordionId,
    "data-parent": "customization-accordion-".concat(accordionId),
    "aria-labelledby": "accordion-heading-".concat(accordionId),
    className: "cb-menu-detail__customization-item"
  }, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
    className: "visuallyhidden"
  }, description), /*#__PURE__*/React.createElement(Row, {
    className: "cb-menu-detail__customization-group"
  }, /*#__PURE__*/React.createElement(CustomizationOptions, {
    options: options,
    defaultOptionName: defaultOptionName,
    inputType: inputType,
    mandatory: mandatory,
    parentId: parentId,
    isSides: isSides,
    controlledValues: controlledValues,
    handleCounter: handleCounter,
    handleRadio: handleRadio,
    handleCheckbox: handleCheckbox,
    remaining: remaining,
    currentElement: element,
    multiplesAllowed: multiplesAllowed,
    isEditMode: isEditMode,
    groupIndex: index
  }))))))));
};
export var CustomizationOptions = function CustomizationOptions(props) {
  var _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      defaultOptionName = props.defaultOptionName,
      _props$inputType = props.inputType,
      inputType = _props$inputType === void 0 ? {} : _props$inputType,
      _props$mandatory = props.mandatory,
      mandatory = _props$mandatory === void 0 ? false : _props$mandatory,
      parentId = props.parentId,
      _props$isSides = props.isSides,
      isSides = _props$isSides === void 0 ? false : _props$isSides,
      controlledValues = props.controlledValues,
      _handleCounter = props.handleCounter,
      handleRadio = props.handleRadio,
      handleCheckbox = props.handleCheckbox,
      remaining = props.remaining,
      index = props.index,
      _props$multiplesAllow = props.multiplesAllowed,
      multiplesAllowed = _props$multiplesAllow === void 0 ? false : _props$multiplesAllow,
      _props$currentElement = props.currentElement,
      currentElement = _props$currentElement === void 0 ? {} : _props$currentElement,
      isEditMode = props.isEditMode,
      groupIndex = props.groupIndex;
  var _currentElement$selec = currentElement.selectedOptions,
      selectedOptions = _currentElement$selec === void 0 ? [] : _currentElement$selec;

  var _onChange = mandatory ? handleRadio : handleCheckbox;

  return options.map(function (child, index) {
    var _selectedOptions$;

    var title = child.optionName,
        image = child.optionImagePath,
        calorie = child.basecalories,
        additionalCost = child.cost,
        groupId = child.optionGroupId,
        childChain = child.chainId,
        childOption = child.optionId;
    var control = null;

    if (selectedOptions) {
      control = selectedOptions.filter(function (option) {
        return (option === null || option === void 0 ? void 0 : option.optionId) === childOption;
      }).length;
    } // selectedOptions[0]?.optionId === childOption
    //ifEditMode, runOnChange


    if (isEditMode && control && ((_selectedOptions$ = selectedOptions[0]) === null || _selectedOptions$ === void 0 ? void 0 : _selectedOptions$.cost) === undefined) {
      _onChange(childChain, childOption, additionalCost, title);
    }

    var defaultOption = false;

    if (child.isSelected) {
      var _selectedOptions$2;

      defaultOption = true;

      if (!isEditMode && ((_selectedOptions$2 = selectedOptions[0]) === null || _selectedOptions$2 === void 0 ? void 0 : _selectedOptions$2.cost) === undefined) {
        console.log('Preselect: ', title);

        _onChange(childChain, childOption, additionalCost, title);
      }
    }

    return /*#__PURE__*/React.createElement(Col, {
      lg: 3,
      md: 4,
      sm: 12,
      className: "pb-12",
      key: "customization_".concat(groupId, "_").concat(index)
    }, /*#__PURE__*/React.createElement(SelectableAddon, {
      index: index,
      defaultOption: defaultOption,
      chainId: childChain,
      groupId: groupId,
      optionId: childOption,
      required: mandatory,
      inputType: inputType,
      parentId: parentId,
      additionalCost: additionalCost,
      displayName: title,
      controlledValues: controlledValues,
      control: control,
      onChange: function onChange(idName, optionId, additionalCost, displayName, elem) {
        _onChange(idName, optionId, additionalCost, displayName, elem);
      } //in case it breaks add back the onChange
      ,
      isEditMode: true
    }, /*#__PURE__*/React.createElement(CustomizationImage, {
      media: {
        value: {
          src: image,
          alt: title
        }
      },
      className: "cb-menu-detail__image"
    }), /*#__PURE__*/React.createElement("div", {
      className: "cb-menu-detail__selectable-addon--bottom"
    }, title ? /*#__PURE__*/React.createElement(RichText, {
      field: {
        value: typeof title === "string" ? title : String(title)
      }
    }) : null, /*#__PURE__*/React.createElement(DividedContainer, {
      className: "p-0 flex-md-column align-items-md-start"
    }, calorie ? /*#__PURE__*/React.createElement(CustomizationValue, {
      value: {
        value: typeof calorie === "string" ? calorie : String(calorie)
      },
      extraMarkupCalorie: " calories"
    }) : null, additionalCost ? /*#__PURE__*/React.createElement(CustomizationValue, {
      value: {
        value: typeof additionalCost === "string" ? additionalCost : parseFloat(additionalCost).toFixed(2)
      },
      extraMarkupPrice: "+$"
    }) : null), isSides && /*#__PURE__*/React.createElement(Included, {
      handleCounter: function handleCounter(amt) {
        return _handleCounter(amt, childChain, parentId, additionalCost, title);
      },
      controlledValue: controlledValues.find(function (element) {
        return title === (element === null || element === void 0 ? void 0 : element.optionName);
      }),
      remaining: remaining
    }))));
  });
};
export var CustomizationImage = function CustomizationImage(_ref2) {
  var media = _ref2.media,
      className = _ref2.className;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      errored = _useState2[0],
      setErrored = _useState2[1];

  function setMediaSrcToAbsolutePath(media) {
    // to support mobile app
    media.value.src = UTIL.apiUtil.API.baseUrl + media.value.src;
    return media;
  }

  useEffect(function () {
    var _media$value, _media$value2;

    if (!Boolean(media === null || media === void 0 ? void 0 : (_media$value = media.value) === null || _media$value === void 0 ? void 0 : _media$value.src) || (media === null || media === void 0 ? void 0 : (_media$value2 = media.value) === null || _media$value2 === void 0 ? void 0 : _media$value2.src) === '') {
      setErrored(true);
    }
  }, []);
  return errored ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " cb-menu-detail__noimage")
  }) : /*#__PURE__*/React.createElement(Image, {
    media: setMediaSrcToAbsolutePath(media),
    className: className,
    onError: function onError() {
      return setErrored(true);
    }
  });
};
export var CustomizationValue = function CustomizationValue(_ref3) {
  var value = _ref3.value,
      extraMarkupPrice = _ref3.extraMarkupPrice,
      extraMarkupCalorie = _ref3.extraMarkupCalorie;
  return Boolean(value.value) ? /*#__PURE__*/React.createElement("span", {
    className: "cb-menu-detail__subcontent"
  }, extraMarkupPrice, /*#__PURE__*/React.createElement(RichText, {
    field: value,
    className: "d-inline-block"
  }), extraMarkupCalorie) : "";
};

var Included = function Included(_ref4) {
  var _ref4$remaining = _ref4.remaining,
      remaining = _ref4$remaining === void 0 ? 1 : _ref4$remaining,
      _ref4$controlledValue = _ref4.controlledValue,
      controlledValue = _ref4$controlledValue === void 0 ? {} : _ref4$controlledValue,
      _ref4$handleCounter = _ref4.handleCounter,
      handleCounter = _ref4$handleCounter === void 0 ? function () {
    return "";
  } : _ref4$handleCounter;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-menu__included"
  }, /*#__PURE__*/React.createElement("span", null, "Included"), /*#__PURE__*/React.createElement(Counter, {
    setValue: handleCounter,
    counterValues: {
      min: 1,
      max: remaining + controlledValue.quantity
    },
    value: controlledValue.quantity,
    className: "cb-menu-counter--sm"
  }));
};